import { useState, useEffect } from 'react';

const WATCH_QUERY = '(max-width: 300px)';
const WATCHLG_QUERY = '(max-width: 520px)';

export type WatchTier = 'watch' | 'watchlg' | false;

/** Returns 'watch' for tiny watch (≤300px), 'watchlg' for large watch (301-520px), or false */
export function useWatchTier(): WatchTier {
  const [tier, setTier] = useState<WatchTier>(() => {
    if (window.matchMedia(WATCH_QUERY).matches) return 'watch';
    if (window.matchMedia(WATCHLG_QUERY).matches) return 'watchlg';
    return false;
  });

  useEffect(() => {
    const watchMql = window.matchMedia(WATCH_QUERY);
    const watchlgMql = window.matchMedia(WATCHLG_QUERY);

    const update = () => {
      if (watchMql.matches) setTier('watch');
      else if (watchlgMql.matches) setTier('watchlg');
      else setTier(false);
    };

    watchMql.addEventListener('change', update);
    watchlgMql.addEventListener('change', update);
    return () => {
      watchMql.removeEventListener('change', update);
      watchlgMql.removeEventListener('change', update);
    };
  }, []);

  useEffect(() => {
    document.body.classList.toggle('watch-device', tier === 'watch');
    document.body.classList.toggle('watchlg-device', tier === 'watchlg' || tier === 'watch');
  }, [tier]);

  return tier;
}

/** Returns true for either watch tier (≤520px) */
export function useIsAnyWatch(): boolean {
  const tier = useWatchTier();
  return tier !== false;
}

/** Backward-compatible: true only for tiny watch (≤300px) */
export function useIsWatch(): boolean {
  const tier = useWatchTier();
  return tier === 'watch';
}
